// extracted by mini-css-extract-plugin
export default {"accountStatus":"settingsAccountStatus_accountStatus__1x9rG","closeAccountBtn":"settingsAccountStatus_closeAccountBtn__93kif"};